module.exports = __webpack_public_path__ + "img/kcxq.b469ab21.png";